import { Injectable } from '@angular/core';
import { Workflow, DataSrc } from '../../models/workflow/workflow.model';
import { PlatformComponent } from '../../models/workflow/Model.model';
import { workflowBuilderComponent } from '../../workflow-builder/workflow-builder.component';
import { ComponentParameter } from '../../models/mlmodel/mlModel-parameters.model';
import { InputParameter } from '../../models/workflow/inputParameters.model';
import { OutputParameter } from '../../models/workflow/outputParameters.model';
import { ParameterModel } from 'src/app/models/workflow/parameter.model';

@Injectable({
  providedIn: 'root'
})

export class WorkflowEventsHandler {

  calculateInitialComponents(workflow: Workflow) {
    workflow.initialComponentUniqueIds = [];
    workflow.component.filter(m => m.srcComponent.length == 0).forEach((component) => {
      workflow.initialComponentUniqueIds.push(component.componentUniqueId);
    });
  }

  addComponent(workflowBuilder: workflowBuilderComponent, componentUniqueId, componentId, componentName, componentType) {
    let platformComponent = new PlatformComponent();
    platformComponent.componentUniqueId = componentUniqueId;
    platformComponent.componentId = componentId;
    platformComponent.componentName = componentName;
    platformComponent.componentType = componentType;
    this.setUpModelParameters(platformComponent, workflowBuilder, componentName, componentType);

    workflowBuilder.workflow.component.push(platformComponent);
  }

  setUpModelParameters(platformComponent: PlatformComponent, workflowBuilder: workflowBuilderComponent, componentName, componentType) {
    if (componentType == "CUSTOM") {
      workflowBuilder.workflowService.getInputParameters(platformComponent.componentId).subscribe((data: any): void => {
        this.addInputParameter(platformComponent, data);
        workflowBuilder.isLoading = false;
      }, (error: Error) => { });

      workflowBuilder.workflowService.getOutPutarameters(platformComponent.componentId).subscribe((data: any): void => {
        this.addOutputParameter(platformComponent, data);
        workflowBuilder.isLoading = false;
      }, (error: Error) => { });
    } 
    else if (componentType == "ACTION" || componentType == "EVENT" || componentType == "STANDARD") {
      workflowBuilder.workflowService.getCustomCompParamList(false, componentName).subscribe((data: any): void => {
        this.addInputParameter(platformComponent, data.inputParamters);
        this.addOutputParameter(platformComponent, data.outputParamters);
        workflowBuilder.isLoading = false;
      }, (error: Error) => { });
    }
  }

  addInputParameter(platformComponent: PlatformComponent, inputParameters: any) {
    if (inputParameters) {
      inputParameters.forEach((param) => {
        let inputParam = new InputParameter();
        inputParam.data = this.parseParameterData(param);
        platformComponent.inputParameters.push(inputParam);
      });
    }
  }

  addOutputParameter(platformComponent: PlatformComponent, outputParameters: any) {
    if (outputParameters) {
      outputParameters.forEach((param) => {
        let outputParam = new OutputParameter();
        outputParam.data = this.parseParameterData(param);
        platformComponent.outputParameters.push(outputParam);
      });
    }
  }

  parseParameterData(param: any): ComponentParameter {
    let parameter = new ComponentParameter();
    parameter.parameterId = param.parameterId;
    parameter.parameterName = param.parameterName;
    parameter.parameterDefaultValue = param.parameterDefaultValue;
    parameter.parameterDataType = param.parameterDataType != undefined ? param.parameterDataType : typeof (param.parameterDefaultValue);
    parameter.captionName = param.captionName != undefined ? param.captionName : param.parameterName;

    return parameter;
  }

  removeComponent(workflow: Workflow, componentUniqueId) {
    let index = workflow.component.findIndex(m => m.componentUniqueId == componentUniqueId);
    if (index > -1) {
      // remove component from flowsheet
      workflow.component.splice(index, 1);
      index = workflow.initialComponentUniqueIds.findIndex(m => m == componentUniqueId);
      workflow.initialComponentUniqueIds.splice(index, 1);
    }
  }

  resetParameterSrcMapData(param: InputParameter) {
    param.mappedDataSource = DataSrc.user;
    param.mappedDataSourceId = '';
    param.mappedParameterId = 0;
    param.mappedParameterName = '';
    param.mappedFrequency = 0;
  }

  returnParameterToOriginalPosition(paramList, param) {
    let args = paramList
    .filter(p => p.data.parameterId < param.data.parameterId)
    .map(function (p) { return p.data.parameterId; });
    let prevIndex = Math.max(...args);
    prevIndex = prevIndex < 0 ? 0 : prevIndex;
    paramList.splice(prevIndex, 0, param);
  }

  updateParameterMapping(parameterModel : ParameterModel) {
    if (parameterModel.model.inputParameters.length > 0) {
      let param = parameterModel.model.inputParameters.find(p => p.data.parameterId == parameterModel.parameterId);

      param.mappedDataSource = parameterModel.dataSource;
      param.mappedDataSourceId = parameterModel.dataSourceId;
      param.mappedFrequency = parameterModel.srcFrequency;
      param.mappedParameterId = parameterModel.srcParameterId;
      param.mappedParameterName = parameterModel.srcParameterName;
      param.data.parameterDefaultValue = parameterModel.defaultValue;
    }
  }
}

